import { render, staticRenderFns } from "./epasCopyReport.vue?vue&type=template&id=64b99552&scoped=true&"
import script from "./epasCopyReport.vue?vue&type=script&lang=js&"
export * from "./epasCopyReport.vue?vue&type=script&lang=js&"
import style0 from "./epasCopyReport.vue?vue&type=style&index=0&id=64b99552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b99552",
  null
  
)

export default component.exports